<ng-container *ngIf="notification">
    <ds-notification
        *ngIf="timezone$ | async as timezone"
        theme="warning"
        [header]="'Warning - Trip ID ' + notification.TripId"
        [content]="
            notification.TripId +
            ' has a ' +
            notification.Category +
            ' flag that needs to be resolved by ' +
            (notification.FollowUpTime | convertDate: timezone | date: 'MM/dd/yyyy, HH:mm a') +
            ' ' +
            (timezone.shortName | timezoneAbbreviation)
        "
        (viewClick)="onViewServiceRequest()"
        (dismissClick)="closeNotification()"
    ></ds-notification>
</ng-container>
